import { render, staticRenderFns } from "./FormFactura.vue?vue&type=template&id=50301097&scoped=true&"
import script from "./FormFactura.vue?vue&type=script&lang=js&"
export * from "./FormFactura.vue?vue&type=script&lang=js&"
import style0 from "./FormFactura.vue?vue&type=style&index=0&id=50301097&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50301097",
  null
  
)

export default component.exports